import axios from 'axios';
import * as types from '../../../constant/actionTypes';
import { HOST, EX_DB, } from '../../../constant';

export function fetchDataError(err) {
  return {
    type: types.SYMBOL_SUMMARY_SYMBOL_DETAIL_ERROR,
    payload: {
      msg: '市場預測頁面資料請求: ' + err.message + ' 請稍候再試',
    },
  };
}

export function fetchDataSuccess(response, year, month, report) {
  return {
    type: types.SYMBOL_SUMMARY_SYMBOL_DETAIL_SUCCESS,
    payload: {
      year,
      month,
      data: response.data.data,
      report,
      // data: response.data
    },
  };
}

export function fetchDataRequest() {
  return {
    type: types.SYMBOL_SUMMARY_SYMBOL_DETAIL_REQUEST,
  };
}

const fetchData = (company, year, month, authorization, ids, report) => {
  return (dispatch) => {
    dispatch(fetchDataRequest());
    const options = {
      method: 'POST',
      headers: {
        authorization,
      },
      data: {
        ids,
        fields: 'NULL',
      },
      url: `${HOST}/saber/report/select/${EX_DB}/${company}/symbol_detail/monthly/${year}/${month}/symbol_details`,
    };
    return axios(options)
      .then(json => dispatch(fetchDataSuccess(json, year, month, report)))
      .catch(err => dispatch(fetchDataError(err))); // PAGE_ERROR
  };
};

export default fetchData;



// WEBPACK FOOTER //
// ./src/scenes/SymbolSummary/actions/fetchSymbolDetail.js